export default "__VITE_ASSET__Bl$BU0ji__"